import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const industries = [
  "Transportation & Logistics",
  "Healthcare",
  "Financial Services",
  "Manufacturing",
  "Retail & E-Commerce",
  "Education",
];

export function IndustriesSection() {
  return (
    <section data-testid="industries-section" className="bg-slate-900 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">
            Trusted by Leading Industries
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white font-['Outfit']">
            Industries We Serve
          </h2>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-slate-700">
          {industries.map((industry) => (
            <div 
              key={industry}
              className="bg-slate-800 p-6 text-center border border-slate-700 hover:bg-slate-700 transition-colors"
            >
              <p className="text-white text-sm font-medium font-['Plus_Jakarta_Sans']">
                {industry}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-10 text-center">
          <Link to="/industries">
            <Button 
              variant="outline"
              className="border-white text-white hover:bg-white hover:text-slate-900 rounded-none px-8"
            >
              Explore Industries
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
